import { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { firestore } from "../firebase";

export default function useNewReleases() {
  const [slides, setSlides] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    async function load() {
      try {
        const snap = await getDoc(doc(firestore, "portalWidgets", "newReleases"));

        if (!mounted) return;

        const data = snap.exists() ? snap.data() : null;
        const entries = Array.isArray(data?.entries) ? data.entries : [];

        const visibleSlides = entries
          .filter((entry) => entry?.visible === true)
          .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
          .map((entry) => ({
            image: entry.imageUrl,
            caption: entry.title,
            linkTo: entry.linkTo || null,
          }));

        setSlides(visibleSlides);
      } catch (error) {
        console.error("Error loading new releases widget:", error);
        if (!mounted) return;
        setSlides([]);
      } finally {
        if (!mounted) return;
        setLoading(false);
      }
    }

    load();

    return () => {
      mounted = false;
    };
  }, []);

  return { slides, loading };
}
